
import {getRandomIntInclusive} from '~/plugins/generators';

export default {
  name: 'CustomDropzoneInput',
  props: {
    dropzone: {
      type: Object,
      required: true,
    },
    isValid: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      inputId: `dropzone__input${getRandomIntInclusive(1, 1000000)}`,
    }
  },
  computed: {
    maxFilesize() {
      return this.dropzone.fileSize / 1000
    },
    isMultiple() {
      return this.dropzone.fileNum > 1
    },
  },
  methods: {
    onInputChange(e) {
      this.$emit('filesChange', [ ...e.target.files ])
      e.target.value = null
    },
  },
}
